<template>
  <div class="modal fade" :id="id" data-bs-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
      <form @submit.prevent="submitData" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('access.card.configure')}}</h5> <!-- Changé le titre -->
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal" aria-label="Close">
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"/>
                </svg>
              </span>
            </div>
          </div>
          <div class="modal-body" style="min-height: 60vh; max-height: 75vh;">
            <div class="row">
              <div class="col-4 border-end" style="height: 60vh;">
                <div class="d-flex align-items-center justify-content-end">
                  <div class="dropdown">
                    <button class="btn btn-sm btn-primary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="bi bi-plus fs-2"></i>
                      {{ $t('button.add') }}
                    </button>
                    <ul class="dropdown-menu min-w-150px">
                      <li>
                        <a href="#" @click.prevent="toggleModal('#create_perimeter_modal')" class="dropdown-item px-3">
                          <span class="">
                            <span class="me-4 fs-3 text-hover-primary">
                              <svg  width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <mask id="mask0_4995_3124322" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="22" height="17">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.50024 1L21.0001 6V16H7.50024V1Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M7.49992 1L1 6V16H7.49992" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M16.4997 16V10L11.9998 8.5V16" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M21.0001 16H7.50024" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </mask>
                                <g mask="url(#mask0_4995_3124322)">
                                  <path d="M-1 -6H22.9997V18H-1V-6Z" fill="currentColor"/>
                                  <path d="M-1 -6H22.9997V18H-1V-6Z" fill="black" fill-opacity="0.2"/>
                                </g>
                              </svg>
                            </span>
                            <span> {{ $t('access.newPerimeter') }} </span>
                          </span>
                        </a>
                      </li>
                      <li>
                        <a href="#" @click.prevent="toggleModal('#create_door_modal')" class="dropdown-item px-3">
                      <span class="">
                        <span class="me-4 fs-3 text-hover-primary">
                          <svg width="22" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.961921 17C0.819921 17 0.700921 16.952 0.604921 16.856C0.508921 16.76 0.461254 16.641 0.461921 16.499C0.462588 16.357 0.510254 16.2383 0.604921 16.143C0.699588 16.0477 0.818588 16 0.961921 16H1.99992V2.116C1.99992 1.67133 2.15825 1.291 2.47492 0.975C2.79159 0.659 3.17159 0.500667 3.61492 0.5H12.3849C12.8289 0.5 13.2089 0.658333 13.5249 0.975C13.8409 1.29167 13.9993 1.67167 13.9999 2.115V16H15.0389C15.1803 16 15.2989 16.048 15.3949 16.144C15.4909 16.24 15.5386 16.359 15.5379 16.501C15.5373 16.643 15.4896 16.7617 15.3949 16.857C15.3003 16.9523 15.1813 17 15.0379 17H0.961921ZM12.9999 16V2.116C12.9999 1.936 12.9423 1.78833 12.8269 1.673C12.7116 1.55767 12.5643 1.5 12.3849 1.5H8.84592V1.016C9.46392 1.08467 9.97725 1.35 10.3859 1.812C10.7946 2.274 10.9993 2.81233 10.9999 3.427V14.739C10.9999 15.1417 10.8609 15.4993 10.5829 15.812C10.3049 16.1247 9.96259 16.3033 9.55592 16.348V16H12.9999ZM7.00992 9.77C7.22259 9.77 7.40225 9.69333 7.54892 9.54C7.69559 9.38667 7.76892 9.20333 7.76892 8.99C7.76892 8.77667 7.69525 8.597 7.54792 8.451C7.40059 8.305 7.21792 8.23167 6.99992 8.231C6.79325 8.231 6.61325 8.30467 6.45992 8.452C6.30659 8.59933 6.22992 8.782 6.22992 9C6.22992 9.20667 6.30659 9.38667 6.45992 9.54C6.61325 9.69333 6.79659 9.77 7.00992 9.77Z" fill="currentColor"/>
                            <path d="M0.961921 17C0.819921 17 0.700921 16.952 0.604921 16.856C0.508921 16.76 0.461254 16.641 0.461921 16.499C0.462588 16.357 0.510254 16.2383 0.604921 16.143C0.699588 16.0477 0.818588 16 0.961921 16H1.99992V2.116C1.99992 1.67133 2.15825 1.291 2.47492 0.975C2.79159 0.659 3.17159 0.500667 3.61492 0.5H12.3849C12.8289 0.5 13.2089 0.658333 13.5249 0.975C13.8409 1.29167 13.9993 1.67167 13.9999 2.115V16H15.0389C15.1803 16 15.2989 16.048 15.3949 16.144C15.4909 16.24 15.5386 16.359 15.5379 16.501C15.5373 16.643 15.4896 16.7617 15.3949 16.857C15.3003 16.9523 15.1813 17 15.0379 17H0.961921ZM12.9999 16V2.116C12.9999 1.936 12.9423 1.78833 12.8269 1.673C12.7116 1.55767 12.5643 1.5 12.3849 1.5H8.84592V1.016C9.46392 1.08467 9.97725 1.35 10.3859 1.812C10.7946 2.274 10.9993 2.81233 10.9999 3.427V14.739C10.9999 15.1417 10.8609 15.4993 10.5829 15.812C10.3049 16.1247 9.96259 16.3033 9.55592 16.348V16H12.9999ZM7.00992 9.77C7.22259 9.77 7.40225 9.69333 7.54892 9.54C7.69559 9.38667 7.76892 9.20333 7.76892 8.99C7.76892 8.77667 7.69525 8.597 7.54792 8.451C7.40059 8.305 7.21792 8.23167 6.99992 8.231C6.79325 8.231 6.61325 8.30467 6.45992 8.452C6.30659 8.59933 6.22992 8.782 6.22992 9C6.22992 9.20667 6.30659 9.38667 6.45992 9.54C6.61325 9.69333 6.79659 9.77 7.00992 9.77Z" fill="black" fill-opacity="0.2"/>
                          </svg>
                        </span>
                        <span> {{ $t('access.newDoor') }} </span>
                      </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div v-if="formatedPerimeters.length" class="card-body p-0 px-2">
                  <CardDoorsTree
                      :perimeters="formatedPerimeters"
                      v-model="currentSelected"
                      :doorsWithCardConfig="doorsWithCardConfig"
                      @reload="reloadTreeData"
                  />
                </div>
              </div>
              <div class="col-8" style="height: 60vh; overflow-y: auto;">
                <div v-if="!currentSelected" class="h-100">
                  <div class="d-flex flex-column justify-content-center align-items-center" style="height: 100%">
                    <i class="fas fa-file-alt fa-5x text-gray-300 mb-5"></i>
                    <h3 class="text-gray-500">{{$t('access.card.noDoorOrPerimeterSelected')}}</h3>
                  </div>
                </div>
                <div v-else class="h-100">
                  <div class="alert alert-warning mb-5" role="alert">
                    <em> {{ $t('access.card.noSavedDataWillLost') }} </em>
                  </div>
                  <div class="col-12 mb-5">
                    <div class="d-flex justify-content-between align-items-center">
                      <Card class="card shadow-sm border border-gray-300 p-0">
                        <div class="h-50px p-0 px-3 py-2 d-flex align-items-center">
                          <SwitchInput
                              left
                              :label="$t('access.configAccess.authoriseAccess')"
                              v-model="formData.enabled"
                          />
                        </div>
                      </Card>
                      <RequiredText :text="$t('access.configAccess.authoriseAccessWarn')"/>
                    </div>
                  </div>
                  <div class="col-12 mb-5">
                    <Card class="card shadow-sm border border-gray-300">
                      <template #cardHeader>
                        <div class="card-header">
                          <h4 class="card-title">{{ $t('access.configAccess.accessHours') }}</h4>
                        </div>
                      </template>
                      <template #cardBody>
                        <div class="card-body p-0 p-2">
                          <AccessHours
                              :canEditHours="true"
                              :hours="formData.schedules" />
                        </div>
                      </template>
                    </Card>
                  </div>
                  <div class="d-flex justify-content-end">
                    <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.close" @click="closeModal"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <CreateDoors @load="loadData" id="create_door_modal" :parent="id" />
  <CreatePerimeter @load="loadData" id="create_perimeter_modal" :parent="id" />
</template>

<script setup>
import {ref, defineProps, computed, onMounted, watch} from 'vue'
import {useStore} from "vuex";
import Button from "@/components/Button.vue"
import CardDoorsTree from "./CardDoorsTree.vue";
import CreateDoors from "@/Modules/Access/components/Modals/Doors/CreateOrUpdateDoors.vue";
import CreatePerimeter from "@/Modules/Access/components/Modals/Perimeters/CreateOrUpdatePerimeter.vue";
import SwitchInput from "@/components/SwitchInput.vue";
import Card from "@/components/Card.vue";
import RequiredText from "@/components/RequiredText.vue";
import AccessHours from "@/Modules/Access/views/Config/components/AccessHours.vue";

const store = useStore()

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  cardId: { type: String, required: true },
})
const emits = defineEmits(['callback'])

const formData = ref({
  enabled: false,
  schedules: []
})
const currentSelected = ref('')
const cardConfigs = ref([])
const isLoading = ref(false)

const contacts = computed(() => store.getters["contacts/getContacts"] || [])
const users = computed(() => store.getters["user/getUsers"] || [])
const perimeters = computed(() => store.getters['perimeters/getMainPerimeters'])
const doorsWithCardConfig = computed(() => cardConfigs.value.filter(c => !!c?.enabled || (c?.schedules && Object.keys(c.schedules).length)).map(c => c.id) || [])


const formatedPerimeters = computed(() => {
  if(!perimeters.value.length) return []
  return formatTreeData(perimeters.value)
})
const currentPerimeter = computed(() => {
  if(!currentSelected.value) return null
  return findNodeById(formatedPerimeters.value, currentSelected.value)
})

watch(() => props.cardId, (value) => {
  if(value) {
    resetForm();
    getCardConfig();
  }
}, { deep: true, immediate: true });


watch(() => currentPerimeter.value, (value) => {
  if(value) {
    const selectedConfig = getCurrentDoorConfig()
    formData.value = {
      enabled: !!selectedConfig?.enabled,
      schedules: selectedConfig?.schedules ? Object.entries(selectedConfig?.schedules).map(([day_id, hours]) => ({day_id, hours})) : []
    };
  }
}, { deep: true, immediate: true });


function toggleModal(modalId) {
  $('#'+props.id).modal('toggle')
  $(modalId).modal('toggle')
}
function closeModal(){
  $('#'+props.id).modal('hide');
  resetForm();
}
function resetForm() {
  currentSelected.value = ''
  formData.value = {
    enabled: false,
    schedules: []
  };
}
function formatTreeData(data, isStat = true) {
  let tree = []
  data.forEach(perimeter => {
    let node = {
      id: perimeter.id,
      name: perimeter.name,
      accessMethods: perimeter.accessMethods,
      children: [],
      isStat,
      isDoor: !perimeter?.doors && !perimeter?.children,
    }

    if (perimeter.children && perimeter.children?.length) {
      const formattedChildren = formatTreeData(perimeter.children, false)
      node.children.push(...formattedChildren)
    }

    if (perimeter.doors && perimeter.doors?.length) {
      const formattedDoors = formatTreeData(perimeter.doors, false)
      node.children.push(...formattedDoors)
    }

    tree.push(node)
  })

  return tree
}
function findNodeById(tree, id) {
  for (const node of tree) {
    if (node.id === id) {
      return node
    }

    if (node.children && node.children.length) {
      const found = findNodeById(node.children, id)
      if (found) {
        return found
      }
    }
  }

  return null
}
function reloadTreeData() {
  store.dispatch('perimeters/loadMainPerimeters')
  store.dispatch("perimeters/loadPerimeters")
}

function getCardConfig() {
  store.dispatch('cards/getCardConfig', props.cardId)
    .then((response) => {
      if(response && response.data && response.data.data) {
        const configs = response.data.data.configurations || [];
        cardConfigs.value = configs;
        if(configs.length && currentSelected.value) {
          const selectedConfig = getCurrentDoorConfig()
          formData.value = {
            enabled: !!selectedConfig?.enabled,
            schedules: selectedConfig?.schedules ? Object.entries(selectedConfig?.schedules).map(([day_id, hours]) => ({day_id, hours})) : []
          };
        }
      }
    })
    .catch(err => {})
    .finally();
}

function getCurrentDoorConfig() {
  if(!props.cardId || !currentSelected.value) return null;
  return cardConfigs.value.find(c => c.id === currentSelected.value) || null;
}
function loadData() {
  Promise.all([
    store.dispatch('perimeters/loadMainPerimeters'),
    store.dispatch("perimeters/loadPerimeters"),
    store.dispatch('methods/loadMethods'),
    store.dispatch('access/getDayCollection'),
    store.dispatch('perimeters/loadUserAssignDoorSonote')
  ]).finally(() => isLoading.value = false);
}
function submitData(){
  isLoading.value = true;
  let message = 'notification.card_assigned';


  store.dispatch('cards/setCardConfig', {
    id: props.cardId,
    configs: [
      {  accessible_id: currentSelected.value, ...formData.value }
    ]})
      .then((response) => {
        getCardConfig()
        window.toastr['success'](i18n.global.t(message));
      })
      .catch(err => {})
      .finally(() => isLoading.value = false)
}

onMounted(() => {
  loadData()
  if(props.cardId) {
    getCardConfig();
  }
})
</script>